export default __webpack_public_path__ + "static/media/wp4102995.6c5c33f3.jpg";